import StaffSelectPanel from './src/staff-select-panel';

export default StaffSelectPanel;
